import { useIntl } from '@/intl'
import { Banner } from '@sunwebgroup/uds-ui/banner'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { IconButton } from '@sunwebgroup/ui-components/uds'
import { useSearchParams } from 'next/navigation'
import { useState } from 'react'
import styles from './NotFoundBanner.module.css'

export default function NotFoundBanner() {
  const intl = useIntl()
  const searchParams = useSearchParams()
  const isPageNotFound = searchParams.get('PageNotFound')
  const [displayBanner, setDisplayBanner] = useState(true)

  if (!isPageNotFound || !displayBanner) {
    return null
  }

  return (
    <div data-qa="not-found-destination-page">
      <Banner
        size="S"
        color="informative"
        className={styles.notFoundBanner}
      >
        <Typography variant="body-m-regular-loose">
          {intl.formatMessage({ id: 'destination_banner_not_found_title' })}
        </Typography>
        <Banner.ActionsWrapper actionsPosition="right">
          <IconButton
            glyph="CrossMedium"
            onClick={() => setDisplayBanner(false)}
            size="XS"
          />
        </Banner.ActionsWrapper>
      </Banner>
    </div>
  )
}
